module.exports = {
  title: '查看线下支付权限',
  route: {
    path: '/merchant-manage',
    children: {
      path: 'offline-payment-detail',
    },
  },
};
